// Corporate Catering Menu Data
export const CATERING_MENU = [
  {
    category: 'Sandwiches',
    icon: '🥪',
    items: [
      { id: 'veg-aloo-sandwich', name: 'Veg Aloo Sandwich', price: 99, isVeg: true, image: '/catering/veg-aloo-sandwich.png', tag: 'most-ordered' },
      { id: 'paneer-sandwich', name: 'Paneer Sandwich', price: 130, isVeg: true, image: '/catering/paneer-sandwich.png', tag: 'bestseller' },
      { id: 'veg-cheese-sandwich', name: 'Veg Cheese Sandwich', price: 120, isVeg: true, image: '/catering/veg-cheese-sandwich.png' },
      { id: 'hung-curd-sandwich', name: 'Hung Curd Sandwich', price: 140, isVeg: true, image: '/meals/hung-curd-sandwich.png' },
      { id: 'paneer-cheese-sandwich', name: 'Paneer Cheese Sandwich', price: 150, isVeg: true, image: '/catering/paneer-cheese-sandwich.png' },
      { id: 'chicken-sandwich', name: 'Chicken Sandwich', price: 150, isVeg: false, image: '/catering/chicken-sandwich.png' },
    ],
  },
  {
    category: 'Breakfast',
    icon: '🍽️',
    items: [
      { id: '2-idli', name: '2 Idli', price: 80, isVeg: true, image: '/catering/2-idli.png' },
      { id: 'poha', name: 'Poha', price: 70, isVeg: true, image: '/catering/poha.png' },
      { id: 'poori-sabzi', name: '4 Poori & Sabzi', price: 99, isVeg: true, image: '/catering/poori-sabzi.png', tag: 'most-ordered' },
    ],
  },
  {
    category: 'Healthy Meals',
    icon: '🥗',
    items: [
      { id: 'veg-salad', name: 'Veg Salad', price: 120, isVeg: true, image: '/catering/veg-salad.png', tag: 'healthy-choice' },
      { id: 'chicken-salad', name: 'Chicken Salad', price: 170, isVeg: false, image: '/catering/chicken-salad.png', tag: 'healthy-choice' },
      { id: 'fruit-bowl', name: 'Fruit Bowl', price: 150, isVeg: true, image: '/catering/fruit-bowl.png', tag: 'healthy-choice' },
    ],
  },
  {
    category: 'Biryani',
    icon: '🍚',
    items: [
      { id: 'chicken-biryani', name: 'Chicken Biryani', price: 295, isVeg: false, image: '/catering/chicken-biryani.png', tag: 'bestseller' },
      { id: 'paneer-biryani', name: 'Paneer Biryani', price: 250, isVeg: true, image: '/catering/paneer-biryani.png', tag: 'most-ordered' },
      { id: 'mushroom-biryani', name: 'Mushroom Biryani', price: 240, isVeg: true, image: '/catering/mushroom-biryani.png' },
    ],
  },
  {
    category: 'Parathas',
    icon: '🫓',
    items: [
      { id: 'aloo-paratha', name: 'Aloo Paratha', price: 130, isVeg: true, image: '/catering/aloo-paratha.png', tag: 'bestseller' },
      { id: 'paneer-paratha', name: 'Paneer Paratha', price: 180, isVeg: true, image: '/catering/paneer-paratha.png' },
      { id: 'matar-paratha', name: 'Matar Paratha', price: 140, isVeg: true, image: '/catering/matar-paratha.png' },
    ],
  },
  {
    category: 'Thali',
    icon: '🍛',
    items: [
      { id: 'veg-thali', name: 'Veg Thali', price: 250, isVeg: true, image: '/catering/veg-thali.png', description: 'Paneer Sabzi, Dal Tadka, Rice, Raita, 2 Rotis, Salad' },
    ],
  },
  {
    category: 'Healthy Rolls (No Maida)',
    icon: '🌯',
    items: [
      { id: 'paneer-roll', name: 'Paneer Roll', price: 130, isVeg: true, image: '/catering/paneer-roll.png' },
      { id: 'chicken-roll', name: 'Chicken Roll', price: 130, isVeg: false, image: '/catering/chicken-roll.png' },
      { id: 'egg-paneer-roll', name: 'Egg Paneer Roll', price: 150, isVeg: false, image: '/catering/egg-paneer-roll.png' },
      { id: 'egg-chicken-roll', name: 'Egg Chicken Roll', price: 150, isVeg: false, image: '/catering/egg-chicken-roll.png' },
    ],
  },
  {
    category: 'Burgers',
    icon: '🍔',
    items: [
      { id: 'veg-burger', name: 'Veg Burger', price: 140, isVeg: true, image: '/catering/veg-burger.png' },
      { id: 'chicken-burger', name: 'Chicken Burger', price: 150, isVeg: false, image: '/catering/chicken-burger.png' },
      { id: 'chicken-egg-burger', name: 'Chicken Egg Burger', price: 160, isVeg: false, image: '/catering/chicken-egg-burger.png' },
      { id: 'fries-coke-combo', name: 'Fries + Coke Combo', price: 100, isVeg: true, image: '/catering/fries-coke-combo.png' },
    ],
  },
  {
    category: 'Drinks',
    icon: '🥤',
    items: [
      { id: 'plain-chaas', name: 'Plain Chaas', price: 70, isVeg: true, image: '/catering/plain-chaas.png' },
      { id: 'masala-chaas', name: 'Masala Chaas', price: 80, isVeg: true, image: '/catering/masala-chaas.png', tag: 'most-ordered' },
      { id: 'lassi', name: 'Lassi', price: 80, isVeg: true, image: '/catering/lassi.png' },
      { id: 'mango-lassi', name: 'Mango Lassi', price: 90, isVeg: true, image: '/catering/mango-lassi.png' },
      { id: 'shikanji', name: 'Shikanji', price: 90, isVeg: true, image: '/catering/shikanji.png' },
      { id: 'cold-coffee', name: 'Cold Coffee', price: 90, isVeg: true, image: '/catering/cold-coffee.png' },
    ],
  },
];

// Suggested quantities based on people count (per person ratios)
export const suggestQuantities = (peopleCount) => {
  const suggestions = {};
  // 1 sandwich per person (from popular sandwich)
  suggestions['paneer-sandwich'] = peopleCount;
  // 1 drink per person
  suggestions['masala-chaas'] = peopleCount;
  // 1 fruit bowl for every 2 people
  suggestions['fruit-bowl'] = Math.ceil(peopleCount / 2);
  return suggestions;
};

export const ALL_ITEMS = CATERING_MENU.flatMap((cat) => cat.items);
